import { PizzaTracker } from 'mc-ui/collections/PizzaTracker'
import { Flex, View, Button, Text } from '@instructure/ui'

const SectionsDisplay = ({
  sectionsCount, currentSection, questionsCount,
  onStart, onExit,
}) => {
  const t = window._t;

  const message = t('Section Display Title', {sectionsCount : sectionsCount, questionsCount: questionsCount, nextSection: (currentSection + 1)});

  return (
    <Flex height={'100vh'} justifyItems={'center'}>
      <Flex direction={'column'} alignItems={'center'}>
        <PizzaTracker interaction={'readonly'} size={'large'}>
          {Array(sectionsCount).fill().map((_, index) => (
            <PizzaTracker.Button
              current={index === currentSection}
              checked={index < currentSection}
            >
              {index === currentSection ? `${t('Section')} ${index + 1}` : index + 1}
            </PizzaTracker.Button>
          ))}
        </PizzaTracker>
        <View margin={'xxLarge xxLarge large xxLarge'} textAlign={'center'}>
          <View as={'div'} margin={'0 0 small'}>
            <Text size={'large'} weight={'bold'} color={'primary'} marginHeight>{`${questionsCount} ${t('Questions')} `}</Text>
          </View>
          <Text color={'primary'}>{message}</Text>
        </View>
        <View>
          <Button onClick={onExit} margin={'small'}>{t('Exit')}</Button>
          <Button onClick={onStart} color="primary">{currentSection === 0 ? t('Start') : t('Continue')}</Button>
        </View>
      </Flex>
    </Flex>
  )
}

export { SectionsDisplay }
